// extracted by mini-css-extract-plugin
module.exports = {"radio":"RadioRegister_radio__5IIlx"};